import React from "react"
import Link from "components/Link"

const LINK_NOCAPTURE =
  /(\[(?:\[[^\]]*\]|[^[\]]|\](?=[^[]*\]))*\]\(\s*<?(?:[^\s\\]|\\.)*?>?(?:\s+['"][\s\S]*?['"])?\s*\))/g
const LINK_CAPTURING =
  /\[((?:\[[^\]]*\]|[^[\]]|\](?=[^[]*\]))*)\]\(\s*<?((?:[^\s\\]|\\.)*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*\)/

// Match and replace markdown-style links with the Link component
const renderLinks = value => {
  if (LINK_NOCAPTURE.test(value)) {
    const parts = value.split(LINK_NOCAPTURE)
    return parts.map((part, index) => {
      const match = part.match(LINK_CAPTURING)
      if (match) {
        const [, text, href] = match
        return (
          <Link href={href} key={index}>
            {text}
          </Link>
        )
      }
      return part
    })
  }
  return value
}

export default renderLinks
